// extracted by mini-css-extract-plugin
export default {"wrapper":"H2-z","play":"I2-z"};